export default class BalanceService {

  static BIZ_LOCATION_URL = 'ton/v1/balances/biz-locations';
  static PRODUCT_TYPE_URL = 'ton/v1/balances/product-types';
  static ASSET_URL = "ton/v1/balances/assets";

}



// WEBPACK FOOTER //
// ./src/balance/BalanceService.js